import { useTranslation } from '@jq4race/i18n';
import { Button } from '@jq4race/ui';
import { RefreshCw } from 'lucide-react';
import { useEffect, useState } from 'react';

import { applyUpdate, subscribeUpdateAvailable } from '../../../app/update-available-store';

/**
 * Surfaces the "tap to update" side of the SW update policy (ADR-017 / design
 * D10): a fresh service-worker update that arrives mid-session is NEVER
 * applied automatically (it would reload the page and could drop an
 * in-progress check-in). This banner is the operator's only way to apply it
 * before the next natural app restart.
 */
export function UpdateAvailableToast() {
  const { t } = useTranslation('shell');
  const [available, setAvailable] = useState(false);

  useEffect(() => subscribeUpdateAvailable(setAvailable), []);

  if (!available) return null;

  return (
    <aside
      role="alert"
      className="fixed inset-x-4 bottom-20 z-50 mx-auto max-w-sm rounded-xl border border-border bg-card shadow-lg"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-start gap-3 p-4">
        <RefreshCw className="mt-1 size-5 shrink-0 text-jq-gold-bright" aria-hidden />
        <div className="flex-1">
          <p className="jq-body text-foreground font-semibold">{t('update.title')}</p>
          <p className="mt-1 jq-body-sm text-muted-foreground">{t('update.description')}</p>
        </div>
      </div>
      <div className="px-4 pb-4">
        <Button size="lg" className="w-full" onClick={applyUpdate}>
          {t('update.action')}
        </Button>
      </div>
    </aside>
  );
}
